import React from 'react';
import { FormField, FormFieldLabel, RadioGroup, RadioOption } from 'styles/common.styles';

/**
 * Radio ?�???�드 컴포?�트
 * 
 * @param {Object} props
 * @param {string} props.name - ?�드 ?�름
 * @param {string} props.label - ?�드 ?�벨
 * @param {string} props.value - ?�드 �? * @param {Array} props.options - ?�션 배열 [{ value, label }] ?�는 [string]
 * @param {string} props.width - ?�드 ?�비
 * @param {string} props.flex - flex ?�성
 * @param {string} props.labelWidth - ?�벨 ?�비
 * @param {string} props.fieldWidth - FormField ?�체 ?�비
 * @param {boolean} props.readonly - ?�기 ?�용 ?��?
 * @param {Function} props.onChange - �?변�??�들?? * @param {Object} props.fieldProps - 추�? ?�드 ?�성
 */
const RadioField = ({
  name,
  label,
  value = '',
  options = [],
  width,
  labelWidth,
  fieldWidth,
  showColon = false,
  readonly = false,
  onChange,
  fieldProps = {},
}) => {
  return (
    <FormField
      width={fieldWidth || 'auto'}
    >
      {label && (
        <FormFieldLabel width={labelWidth} >{showColon ? `${label}:` : label}</FormFieldLabel>
      )}
      <RadioGroup>
        {options.map((option) => {
          // options가 { value, label } ?�태??경우
          const optionValue = typeof option === 'object' && option.value !== undefined 
            ? option.value 
            : option;
          const optionLabel = typeof option === 'object' && option.label !== undefined 
            ? option.label 
            : option;
          
          return (
            <RadioOption key={optionValue} disabled={readonly}>
              <input
                type="radio"
                name={name}
                value={optionValue}
                checked={value === optionValue}
                disabled={readonly}
                onChange={readonly ? undefined : onChange}
                width={width || 'auto'}
                {...fieldProps}
              />
              <span>{optionLabel}</span>
            </RadioOption>
          );
        })}
      </RadioGroup>
    </FormField>
  );
};

export default RadioField;

